import { useState } from 'react';
import { navCategories } from '@/mocks/nav';

const toneMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 border-primary-200',
  accent: 'bg-accent-100 text-accent-700 border-accent-200',
  secondary: 'bg-secondary-100 text-secondary-900 border-secondary-200',
};

const filters = [
  { id: 'all', label: '全部分类' },
  { id: 'hot', label: '热门优先' },
  { id: 'new', label: '新收录' },
];

export default function CategoryShowcase() {
  const [active, setActive] = useState('all');

  const list = [...navCategories].sort((a, b) => {
    if (active === 'hot') return b.count - a.count;
    if (active === 'new') return a.count - b.count;
    return 0;
  });

  return (
    <section id="category" className="w-full bg-background-50 py-20 md:py-28">
      <div className="w-full max-w-content mx-auto px-4 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <span className="font-label text-xs tracking-[0.28em] text-secondary-600">CATEGORIES</span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              导航分类，一站找齐常用入口
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              按场景分组的站点集合，收录数量与更新状态一目了然。点击分类即可查看该分组下的全部入口。
            </p>
          </div>

          <div className="flex items-center gap-1 p-1 rounded-full bg-background-100 border border-background-200/70 self-start">
            {filters.map((f) => (
              <button
                key={f.id}
                type="button"
                onClick={() => setActive(f.id)}
                className={`px-4 py-1.5 rounded-full text-sm font-label whitespace-nowrap transition-colors cursor-pointer ${
                  active === f.id
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-600 hover:text-foreground-900'
                }`}
              >
                {f.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {list.map((cat, index) => {
            const isWide = index === 0;
            return (
              <a
                key={cat.id}
                href="#category"
                className={`group rounded-lg p-6 border border-background-200/70 bg-background-50 hover:border-primary-300 transition-colors flex flex-col ${
                  isWide ? 'sm:col-span-2 lg:col-span-2 lg:row-span-2 lg:justify-center' : ''
                }`}
              >
                <div className="flex items-center justify-between">
                  <span
                    className={`w-12 h-12 flex items-center justify-center rounded-lg text-xl border ${
                      toneMap[cat.tone] || toneMap.primary
                    }`}
                  >
                    <i className={cat.icon}></i>
                  </span>
                  <span className="font-heading text-sm text-foreground-400 group-hover:text-primary-600 transition-colors">
                    {cat.count} 个入口
                  </span>
                </div>
                <h3
                  className={`mt-5 font-heading font-bold text-foreground-950 ${
                    isWide ? 'text-xl md:text-2xl' : 'text-lg'
                  }`}
                >
                  {cat.name}
                </h3>
                <p
                  className={`mt-2 leading-relaxed text-foreground-600 ${
                    isWide ? 'text-sm md:text-base' : 'text-sm'
                  }`}
                >
                  {cat.desc}
                </p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-label text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity">
                  查看入口
                  <i className="ri-arrow-right-line"></i>
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}